controllers.controller('HelpDeskController', [
    '$scope', '$state', 'LocaleService',
    function ($scope, $state, LocaleService) {

        LocaleService.wait().then(function (translation) {
            $scope.translation = translation;
        });

    }]);